import { render, staticRenderFns } from "./CrmToolbar.vue?vue&type=template&id=2465f574&scoped=true&"
import script from "./CrmToolbar.vue?vue&type=script&lang=js&"
export * from "./CrmToolbar.vue?vue&type=script&lang=js&"
import style0 from "./CrmToolbar.vue?vue&type=style&index=0&id=2465f574&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465f574",
  null
  
)

export default component.exports